import { UpperCasePipe } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RegisteredSerialsService } from '../../services/registered-serials.service';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { Utils } from '../../services/utils.service';
import { UserDataService } from '../../services/user-data.service';
import { Modal, ModalDismissReasons } from '../../services/modal.service';
import dayjs from 'dayjs';

@Component({
  selector: 'modal-warranty-upload',
  imports: [TranslatePipe, UpperCasePipe, FormsModule, ReactiveFormsModule],
  templateUrl: './warranty-upload.component.html',
  styleUrls: ['./warranty-upload.component.scss']
})
export class WarrantyUploadComponent implements OnInit {

  private modal = inject(Modal);
  private registeredSerialsService = inject(RegisteredSerialsService);
  private translate = inject(TranslateService);
  private fb = inject(FormBuilder);
  private utils = inject(Utils);
  private userDataService = inject(UserDataService);

  allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'application/zip'];
  selectedFile?: File;
  form!: FormGroup;
  submitted = false;
  loading = signal<boolean>(false);

  ngOnInit(): void {
    this.form = this.fb.group({
      date: ['', [Validators.required, this.checkDate]],
      check: [false, [Validators.requiredTrue]],
    });
  }

  close() {
    this.modal.dismiss(ModalDismissReasons.CANCEL);
  }

  onDropped(event: DragEvent) {
    event.preventDefault();
    const file = event.dataTransfer?.files[0];
    const index = this.allowedTypes.indexOf(file?.type ?? '');
    if (file && index !== -1) {
      this.selectedFile = file;
    }
  }

  onSelected(event: Event) {
    const target = event.target as HTMLInputElement;
    if (!target.files) {
      return;
    }
    this.selectedFile = target.files[0];
  }

  clearFile() {
    this.selectedFile = undefined;
  }

  upload() {
    this.submitted = true;
    if (!this.selectedFile || !this.form.valid) {
      return;
    }
    const date = this.form.get('date')?.value ?? '';
    const lang = this.translate.currentLang() ?? 'en';
    this.loading.set(true);
    this.registeredSerialsService.uploadSerialFile(this.modal.params.selectedId, this.selectedFile, date, lang).subscribe({
      next: _ => {
        this.loading.set(false);
        this.modal.dismiss(ModalDismissReasons.OK);
      },
      error: error => {
        this.loading.set(false);
        this.utils.showMessage(error, this.utils.getErrorMessage(error, this.userDataService.user()?.email ?? ''));
      }
    });
  }

  private checkDate(control: FormControl): ValidationErrors | null {
    const date = control.value;
    if (!date) {
      return null;  
    }
    let purchaseDate = dayjs(date);
    if (purchaseDate.diff(dayjs(dayjs().format('YYYY-MM-DD'))) > 0) {
      return {
        invalidDate: true
      }
    }
    return null;
  }
}
